import { Icon } from '@blueprintjs/core';
import ConditionalWrapper from 'Lib/hoc/ConditionalWrapper';
import PropTypes from 'prop-types';

const BOSIcon = ({ icon, title, small = false, large = false, className }) => {
  let size = small ? 20 : large ? 32 : 24;

  return (
    <ConditionalWrapper
      wrapper={(children) => (
        <div
          style={{
            display: 'flex',
            gap: 6,
            alignItems: 'center',
          }}>
          {children}
        </div>
      )}
      condition={!!title}>
      {icon && <Icon icon={icon} className={className} size={size} />}
      {title && <span className={className}>{title}</span>}
    </ConditionalWrapper>
  );
};

BOSIcon.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.element,
  ]),
  small: PropTypes.bool,
  large: PropTypes.bool,
  className: PropTypes.string,
};

export default BOSIcon;
